import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';

import { BaseProvider } from 'src/app/core/services/base-provider';
import { GlobalsService } from 'src/app/core/services/globals.service';
import { UtilsService } from 'src/app/core/services/utils.service';

@Injectable({
  providedIn: 'root',
})
export class CostFormAdminService extends BaseProvider {
  costs: any = [];
  selectedCosts: any = [];
  dynamicCosts: any = [];

  subTotal: any = 0;  
  total: any = 0;  

  taxAmount: any = 0;  
  discountAmount: any = 0;  
  
  totalOfNewCosts: any;
  costsAdded: boolean = true;
  dynamicCostsAdded: boolean = false;

  minimumCostsAdded: boolean = false;
  minimumCostSelectedCount: any = 0;
  minRequiredCosts: any = [];
  constructor(
    public globals: GlobalsService,
    public http: HttpClient,
    public utils: UtilsService,
  ) {
    super();
   
    this.baseUrl = 'userProcessCostInternal';
  }

  save(processId, data){
    return new Promise( (resolve, reject) => {
      this.url = this.globals.dataUrl + this.baseUrl + "/" + processId;

      this.http
      .post(this.url, data)
      .subscribe(
          (data:any) => {
            resolve(data)
           },
          (err:any) => {
            reject(err)
           }
      );
    });    
  }
  createNonDynamicCosts(processId){
    return new Promise( (resolve, reject) => {
      this.url = this.globals.dataUrl + this.baseUrl + "/noDynamicCosts/" + processId;

      this.http
      .post(this.url, null)
      .subscribe(
        (data:any) => {
          resolve(data)
        },
        (err:any) => {
          reject(err)
        }
      );
    });    

  }
  getCosts(processId, costTypeId) {
    console.log('costTypeId',costTypeId)
    return new Promise((resolve, reject) => {
      this.url = this.globals.dataUrl + this.baseUrl + `/${processId}` + `/costType/${costTypeId}`;

      this.http.get(this.url).subscribe(
        (data: any) => {
          this.costs = data.Data;
          this.costsAdded = true;
          resolve(data.Data);
        },
        (err) => {
          this.costsAdded = false;
          reject(err);
        }
      );
    });
  }

  getDynamicCosts(invoiceId) {
    return new Promise((resolve, reject) => {
      this.url = this.globals.dataUrl +  this.baseUrl   + `/dynamic/invoice/${invoiceId}`;

      this.http.get(this.url).subscribe(
        (data: any) => {
          this.dynamicCosts = data.Data;

         
         for(var i = 0; i<this.dynamicCosts.length; i++){
            this.dynamicCosts.Costs = JSON.parse(this.dynamicCosts[i].Costs);
          }

          this.costs = this.dynamicCosts.Costs;
          this.costsAdded = true;
          resolve(data.Data);
         // console.log(this.dynamicCosts.Costs); 
          //resolve(this.dynamicCosts);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }
 
  
  getInvoiceDetail(processId) {
    return new Promise((resolve, reject) => {
      this.url = this.globals.dataUrl + this.baseUrl + `/invoice/detail/process/${processId}`;

      this.http.get(this.url).subscribe(
        (data: any) => {
          this.dynamicCosts = data.Data;

          resolve(data.Data);
        },
        (err) => {

          reject(err);
        }
      );
    });
  }

  manageCost(obj:any){
    let foundItem = this
            .utils
            .returnItemFromListByAttr(this.selectedCosts, "Id", obj.cost.Id);  

    if(!this.utils.isEmpty(foundItem)){
      this
      .utils
      .updateItemFromListByAttr(
        this.selectedCosts, "Id", 
          {
            ...obj.cost,
            ...{Qty:parseInt(obj.qty)}  
          }
      );
    }else{
      this.selectedCosts.push({
        ...obj.cost,
        ...{Qty:parseInt(obj.qty)}          
      });  
    }    
  }  

  removeCost(cost){
    this
    .utils
    .removeItemFromListByAttr(
      this.selectedCosts, 
      "Id",
      cost      
    );    
  }  

  setTotal(){
    this.subTotal = 0;

    this.selectedCosts.forEach((element:any, index) => {
      var amount = (element.FixedAmount>0) ? element.FixedAmount : element.Amount;

      this.subTotal += (amount*element.Qty);
    });    

    this.total = this.subTotal;

    this.total = this.total + this.taxAmount;

    this.setDiscount();
  }  

  setDiscount(){
    if(this.discountAmount<=this.subTotal){
      this.total = (this.subTotal - this.discountAmount) + this.taxAmount;    
    }    
  }  

  setInvoiceTotal(){
    this.subTotal = 0;

    this.selectedCosts.forEach((element:any, index) => {
      var amount = (element.FixedAmount>0) ? element.FixedAmount : element.Amount;

      this.subTotal += (amount*element.Qty);
    });    

    this.total = this.subTotal;

    this.total = this.total + this.taxAmount;

    this.dynamicCostsAdded = false;
    if(this.total > 0){
      this.dynamicCostsAdded = true;
    }
    this.setDiscount();
  }  
}
